import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Checkmark } from 'products/nomad_insurance/assets/img/icons/checkmark-thin.svg';
import { ReactComponent as Unavailable } from 'products/nomad_insurance/assets/img/icons/unavailable.svg';
import LearnMore from './components/LearnMore';
import { StyledAddonCard, Icon, Info, Name, Description, AddButton } from './styled';

const ButtonContent = ({ selected, disabled, subscriptionOnly }) => {
  if (disabled) {
    return (
      <>
        <Unavailable />
        Unavailable
      </>
    );
  }
  if (selected) {
    return (
      <>
        <Checkmark />
        Added
      </>
    );
  }
  if (subscriptionOnly) {
    return (
      <>
        <Unavailable />
        Subscription only
      </>
    );
  }
  return <>+ Add</>;
};

ButtonContent.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  subscriptionOnly: PropTypes.bool
};

const AddonCard = ({
  addon,
  selected,
  onClick,
  disabled,
  showDescription = true,
  subscriptionOnly = false,
  variant = 'default'
}) => {
  const { name, img, description, disabledDescription } = addon;
  return (
    <StyledAddonCard
      $selected={selected}
      $disabled={disabled || subscriptionOnly}
      variant={variant}
    >
      <Icon src={img} alt={name} subscriptionOnly={subscriptionOnly} />
      <Info disabled={subscriptionOnly}>
        <div>
          <Name>{name}</Name>
          {showDescription && (
            <Description>{disabled ? disabledDescription : description}</Description>
          )}
          <LearnMore addonId={addon.id} />
        </div>

        <AddButton
          variant="outline"
          color="pickledBluewood"
          thickness="thin"
          $selected={selected}
          disabled={disabled || subscriptionOnly}
          onClick={() => !disabled && onClick()}
        >
          <ButtonContent
            selected={selected}
            disabled={disabled}
            subscriptionOnly={subscriptionOnly}
          />
        </AddButton>
      </Info>
    </StyledAddonCard>
  );
};

AddonCard.propTypes = {
  addon: PropTypes.object,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  showDescription: PropTypes.bool,
  subscriptionOnly: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'small'])
};

export default AddonCard;
